import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BTSchoolSettingsRequest } from "./BTSchoolSettingsRequest";
import { BTDistrictSettingsRequest } from "./BTDistrictSettingsRequest";
import { BTUserSettingsRequest } from "./BTUserSettingsRequest";
import { BTSUSettingsRequest } from "./BTSUSettingsRequest";

@Injectable()
export class DataService_BusTrackerSettings {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BusTrackerSchoolSettingsSelect(SchoolID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerSchoolSettingsSelect?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerDistrictAndUserSettingsSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerDistrictAndUserSettingsSelect?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerSchoolSettingsUpdate(parms: BTSchoolSettingsRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerSchoolSettingsUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerDistrictSettingsUpdate(parms: BTDistrictSettingsRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerDistrictSettingsUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerUserSettingsUpdate(parms: BTUserSettingsRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerUserSettingsUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerUserSettingsReset(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerUserSettingsReset?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerSchoolSettingsReset(SchoolID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerSchoolSettingsReset?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerSUSettingsSelect() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerSUSettingsSelect?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerSUSettingsUpdate(parms: BTSUSettingsRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerSUSettingsUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SoundSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/SoundSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
